<section class="customize-table">
  <div class="customize-table-header">
    <div class="text">
      <span>Customize table</span>
    </div>
    <div class="close" (click)="justClose()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M15.2457 5.92925C15.5701 5.60478 15.5701 5.07872 15.2457 4.75425C14.9212 4.42978 14.3951 4.42978 14.0707 4.75425L9.99984 8.82508L5.929 4.75425C5.60454 4.42978 5.07847 4.42978 4.754 4.75425C4.42954 5.07872 4.42954 5.60478 4.754 5.92925L8.82484 10.0001L4.754 14.0709C4.42954 14.3954 4.42954 14.9214 4.754 15.2459C5.07847 15.5704 5.60454 15.5704 5.929 15.2459L9.99984 11.1751L14.0707 15.2459C14.3951 15.5704 14.9212 15.5704 15.2457 15.2459C15.5701 14.9214 15.5701 14.3954 15.2457 14.0709L11.1748 10.0001L15.2457 5.92925Z"
          fill="black"
          fill-opacity="0.6"
        />
      </svg>
    </div>
  </div>
  <div class="customize-table-selection-actions">
    <div class="buttons">
      <span class="all" (click)="selectAll()">select all</span>
      <span (click)="clear()">clear</span>
    </div>
  </div>
  <div
    cdkDropList
    class="customize-table-list"
    PreviewContainer="parent"
    (cdkDropListDropped)="drop($any($event))"
  >
    <div class="drop-container">
      <div
        class="col-box"
        cdkDrag
        *ngFor="let col of vm"
        cdkDragBoundary=".drop-container"
      >
        <mat-checkbox
          [(ngModel)]="col.visible"
          [color]="'primary'"
        ></mat-checkbox>
        <span>{{ col.columnName }}</span>
        <div class="move" cdkDragHandle>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M17.4998 8.33341H2.49984C2.27882 8.33341 2.06686 8.24562 1.91058 8.08934C1.7543 7.93306 1.6665 7.7211 1.6665 7.50008C1.6665 7.27907 1.7543 7.06711 1.91058 6.91083C2.06686 6.75455 2.27882 6.66675 2.49984 6.66675H17.4998C17.7209 6.66675 17.9328 6.75455 18.0891 6.91083C18.2454 7.06711 18.3332 7.27907 18.3332 7.50008C18.3332 7.7211 18.2454 7.93306 18.0891 8.08934C17.9328 8.24562 17.7209 8.33341 17.4998 8.33341ZM18.3332 12.5001C18.3332 12.2791 18.2454 12.0671 18.0891 11.9108C17.9328 11.7545 17.7209 11.6667 17.4998 11.6667H2.49984C2.27882 11.6667 2.06686 11.7545 1.91058 11.9108C1.7543 12.0671 1.6665 12.2791 1.6665 12.5001C1.6665 12.7211 1.7543 12.9331 1.91058 13.0893C2.06686 13.2456 2.27882 13.3334 2.49984 13.3334H17.4998C17.7209 13.3334 17.9328 13.2456 18.0891 13.0893C18.2454 12.9331 18.3332 12.7211 18.3332 12.5001Z"
              fill="black"
              fill-opacity="0.6"
            />
          </svg>
        </div>
        <div class="drag-placeholder" *cdkDragPlaceholder></div>
        <div
          *cdkDragPreview
          style="
            background-color: white;
            width: 260px;
            height: 45px;
            display: flex;
            align-items: flex-start;
            padding: 10px;
            gap: 10px;
            border-radius: 4px;
            box-shadow:
              0 5px 5px -3px rgba(0, 0, 0, 0.2),
              0 8px 10px 1px rgba(0, 0, 0, 0.14),
              0 3px 14px 2px rgba(0, 0, 0, 0.12);
          "
        >
          <mat-checkbox
            [(ngModel)]="col.visible"
            [color]="'primary'"
          ></mat-checkbox>
          <span style="flex: 1 0 0">{{ col.columnName }}</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M17.4998 8.33341H2.49984C2.27882 8.33341 2.06686 8.24562 1.91058 8.08934C1.7543 7.93306 1.6665 7.7211 1.6665 7.50008C1.6665 7.27907 1.7543 7.06711 1.91058 6.91083C2.06686 6.75455 2.27882 6.66675 2.49984 6.66675H17.4998C17.7209 6.66675 17.9328 6.75455 18.0891 6.91083C18.2454 7.06711 18.3332 7.27907 18.3332 7.50008C18.3332 7.7211 18.2454 7.93306 18.0891 8.08934C17.9328 8.24562 17.7209 8.33341 17.4998 8.33341ZM18.3332 12.5001C18.3332 12.2791 18.2454 12.0671 18.0891 11.9108C17.9328 11.7545 17.7209 11.6667 17.4998 11.6667H2.49984C2.27882 11.6667 2.06686 11.7545 1.91058 11.9108C1.7543 12.0671 1.6665 12.2791 1.6665 12.5001C1.6665 12.7211 1.7543 12.9331 1.91058 13.0893C2.06686 13.2456 2.27882 13.3334 2.49984 13.3334H17.4998C17.7209 13.3334 17.9328 13.2456 18.0891 13.0893C18.2454 12.9331 18.3332 12.7211 18.3332 12.5001Z"
              fill="black"
              fill-opacity="0.6"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>

  <div class="customize-table-result-actions">
    <div class="buttons">
      <div (click)="justClose()">cancel</div>
      <div class="apply" (click)="apply()">apply</div>
    </div>
  </div>
</section>
